import styled from "@emotion/styled";

import { Tabs } from "metabase/ui";

export const TabPanelRoot = styled(Tabs.Panel)`
  overflow-y: auto;
`;
